import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useDriver } from '../context/DriverContext';
import { useLanguage } from '../i18n/LanguageContext';
import { claimIntertownRequest, declineIntertownOffer, listenToOpenIntertownOffers } from '../services/firebase';

const money = (value) => `₹${Math.round(Number(value) || 0).toLocaleString('en-IN')}`;

export default function OpenIntertownOffers() {
  const { driver, activeRide } = useDriver();
  const { t } = useLanguage();
  const [offers, setOffers] = useState([]);
  const [busyId, setBusyId] = useState('');
  // Declining doesn't touch the shared mirror doc — it must stay visible to
  // every other eligible Anna — so no new snapshot arrives to drop it from
  // *this* Anna's own list. Track locally-declined ids so "Not now" doesn't
  // look like a no-op, and clear one the moment the feed itself moves on
  // (claimed by someone else, expired, reassigned) so this set never grows
  // stale or hides a genuinely different future offer that reuses an id.
  const [declinedIds, setDeclinedIds] = useState(() => new Set());
  useEffect(() => listenToOpenIntertownOffers((next) => {
    setOffers(next);
    setDeclinedIds((prev) => {
      const nextIds = new Set(next.map((offer) => offer.id));
      const stillPresent = [...prev].filter((id) => nextIds.has(id));
      return stillPresent.length === prev.size ? prev : new Set(stillPresent);
    });
  }), []);
  const visibleOffers = offers.filter((offer) => !declinedIds.has(offer.id));
  if (!driver?.isOnline || activeRide || driver?.isOnIntertownTrip || !visibleOffers.length) return null;

  const act = async (offer, claim) => {
    setBusyId(offer.id);
    try {
      if (claim) await claimIntertownRequest(offer.id);
      else {
        await declineIntertownOffer(offer.id);
        setDeclinedIds((prev) => new Set(prev).add(offer.id));
      }
      toast.success(claim ? t('intertown.claimed') : t('intertown.declinedOpen'));
    } catch (error) {
      toast.error(error?.message || t('intertown.claimFailed'));
    } finally { setBusyId(''); }
  };

  return <section className="driver-open-intertown">
    <div className="driver-open-intertown-title"><span>{t('intertown.availableTitle')}</span><small>{t('intertown.availableSubtitle')}</small></div>
    {visibleOffers.map((offer) => <article key={offer.id} className="driver-open-intertown-row">
      <div><strong>{offer.fromName || 'Pileru'} → {offer.toName || t('intertown.destinationFallback')}</strong><span>{offer.distanceKm || '—'} km · {money(offer.baseFare)}</span></div>
      <div className="driver-open-intertown-actions"><button type="button" className="btn btn-ghost" disabled={Boolean(busyId)} onClick={() => act(offer, false)}>{t('intertown.notNow')}</button><button type="button" className="btn btn-green" disabled={Boolean(busyId)} onClick={() => act(offer, true)}>{busyId === offer.id ? t('intertown.updating') : t('intertown.claim')}</button></div>
    </article>)}
  </section>;
}
